<template>
  <NuxtLink v-bind="formattedProps">
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
/**
 * API Link model does not comply with vue-router Link type.
 * We are adding this code to align the behavior of Links with "useRouter".
 */
import { computed } from 'vue'

import type { NuxtLinkProps } from 'nuxt/app'

import { toNuxtLink } from '../utils/toNuxtLink'

const props = defineProps<NuxtLinkProps>()

const formattedProps = computed(() => {
  /**
   * Some props pairs cannot be used together in NuxtLink like
   * prefetch/noPrefetch and rel/noRel.
   * `defineProps` set both to false which will lead to a warning.
   * We deprecate noPrefetch/noRel in favor of prefetch/rel props
   *
   */

  const {
    noPrefetch: _noPrefetch,
    noRel: _noRel,
    target,
    rel,
    ...originalProps
  } = props

  return {
    ...originalProps,
    to: originalProps.to ? toNuxtLink(originalProps.to) : undefined,
    rel: rel ?? undefined,
    target: target ?? undefined,
  }
})
</script>
